import http from "@/http/aisea/axios";
const resource = "/../secure_dataflow/m0";

export default {    

    searchCheckListItemValues(m0checklistId, versionId) {
        // M0チェックリストに対するルームやアイテムの情報取得
        return http.get(`${resource}/m0checklists/${m0checklistId}/rooms`, {
                params: {
                    version_id: versionId,
                }
            });
    },

}
